// extracted by mini-css-extract-plugin
module.exports = {"mobileNegativeMarginTop":"userGeneratedContent_mobileNegativeMarginTop__bExJQ"};